// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsEsDomainsIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-es-domains_svga)" d="M40 0H0v40h40z" />
    <svg width={25} height={31} x={7.5} y={4.5} viewBox="0 0 25 31">
      <path
        fill="#C3C3C3"
        fillRule="evenodd"
        d="M0 23.9V13.3l1.58-.15.75.04-.1 11.37-.65.15z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m4.37 13.29-2.83-.15V24.7l2.83-.68z"
        clipRule="evenodd"
      />
      <path
        fill="#C3C3C3"
        fillRule="evenodd"
        d="M3.05 25.45V8.85l2.67-.83 1.74.34v17.92l-1.74.56z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m10.32 8.92-4.6-.9v18.82l4.6-1.5z"
        clipRule="evenodd"
      />
      <path
        fill="#C3C3C3"
        fillRule="evenodd"
        d="M23.57 8.02v14.04l-3.09-.49V8.58z"
        clipRule="evenodd"
      />
      <path
        fill="#A7A7A7"
        fillRule="evenodd"
        d="m20.52 9.64 2.37-.34V7.19l-8.92-3.35-.64 3.95c0 .04 7.19 1.85 7.19 1.85"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m20.52 20.48 2.37.34v2.14l-7.8 2.72-2.59-3.13z"
        clipRule="evenodd"
      />
      <path
        fill="#C3C3C3"
        fillRule="evenodd"
        d="M7.87 2.22 12.23 0l3.43 1.73-.87 27.07-2.56 1.32-4.36-2.22z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M24.47 6.25v17.62l-12.24 6.25V0zm-1.58 3.09-7-2.11V23l7-2.14z"
        clipRule="evenodd"
      />
    </svg>
    <defs>
      <linearGradient
        id="aws-es-domains_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsEsDomains",
);
export default AwsEsDomainsIcon;
